export enum ProductBadgeType {
  // 품절
  sold_out = 'sold_out',

  // 한정
  limited = 'limited',

  // 수량 한정
  quantity_limited = 'quantity_limited',

  // 기간 한정
  period_limited = 'period_limited',

  // 출시 예정
  upcoming = 'upcoming',

  // 랭킹
  ranking = 'ranking',

  // nft
  nft = 'nft',

  // 멤버십
  membership = 'membership',

  // 인기
  popular = 'popular',

  // 급상승
  trending = 'trending',
}

export enum ProductBadgeSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
  xLarge = 'xLarge',
}

export interface ProductBadgeOption {
  /**
   * @description 타이머를 원하는 시점에 실행하고 싶을 때 활성화
   * @default false
   */
  is_lazy_timer?: boolean;

  /**
   * @description badge label 숨기기
   * @default false
   */
  hide_label?: boolean;

  klass?: string;

  size: ProductBadgeSize;

  /**
   * @default 'auto'
   */
  ratio?: 'auto' | 'square';

  lang: 'kr' | 'en' | 'jp';
}
